/**
 * Lighthouse / PageSpeed Insights / synthetic-monitor detection.
 *
 * When detected, the site renders without heavy 3rd-party scripts (GPT, iZooto,
 * GA, layout codes). Real users always see the full experience because their
 * User-Agent doesn't match these patterns.
 *
 * Patterns matched:
 *   - "Lighthouse" / "Chrome-Lighthouse"      — older Lighthouse versions
 *   - "PageSpeed" / "PageSpeed-Insights"      — Google PSI runner
 *   - "HeadlessChrome"                        — Lighthouse desktop default UA
 *   - "moto g power (2022)"                   — PSI mobile-emulation device UA;
 *                                               PSI uses this exact string when
 *                                               testing form_factor=mobile, and
 *                                               it does not appear in real Chrome
 *                                               UAs that hit our origin (real
 *                                               Moto G Power users get sent
 *                                               through CDN cache anyway)
 *   - "GoogleOther"                           — Google's general crawler bot UA
 *   - "GTmetrix" / "WebPageTest" / "Pingdom"  — synthetic monitors
 *   - User agents containing the literal "headless" token
 */
// Note: not using \b on the moto g power match because the trailing `)` is a
// non-word character — \b after ) doesn't match. Match the literal string instead.
const LIGHTHOUSE_UA_PATTERN =
  /(?:\b(?:Lighthouse|Chrome-Lighthouse|PageSpeed(?:-Insights)?|HeadlessChrome|GoogleOther|GTmetrix|WebPageTest|Pingdom|SpeedCurve|Calibre|DebugBear|headless)\b|moto g power \(2022\))/i;

export function isLighthouseUA(userAgent: string | null | undefined): boolean {
  if (!userAgent) return false;
  return LIGHTHOUSE_UA_PATTERN.test(userAgent);
}

/**
 * Client-side detection. Combines UA string + navigator.webdriver flag.
 * navigator.webdriver is set by Puppeteer / Lighthouse / Selenium and almost
 * never set in real browsers.
 */
export function isLighthouseClient(): boolean {
  if (typeof navigator === 'undefined') return false;
  if (navigator.webdriver === true) return true;
  return isLighthouseUA(navigator.userAgent);
}
